/**
 * Created by jacmai on 6/26/2017.
 */
define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, SortableListModel) {
  "use strict";

  //Request for the headers of the variable prompts list
  Messenger.reqres.setHandler("variable:prompts:headers", function () {
    const Header = SortableListModel.headerModel;
    return new Backbone.Collection([
      new Header({
        headerName: $.t("topics.headers.name"),
        modelAttribute: "name",
        selectable: true,
        longTextField: true,
        sortable: true,
        filterable: true,
      }),
      new Header({
        headerName: $.t("admin.headers.description"),
        modelAttribute: "description",
        longTextField: true,
        sortable: true,
        filterable: true,
      }),
    ]);
  });
});
